"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Slider = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _utils = require("acq-utils/lib/utils");
var _svgFetcher = _interopRequireDefault(require("../../utils/svgFetcher"));
var _useSliderHook = require("./SliderComponents/useSliderHook");
var _SliderControls = require("./SliderComponents/SliderControls");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var SliderControlIcon = (0, _svgFetcher["default"])('dls-icon-right-filled', 'dls', {
  ariaHidden: true
});
var Slider = exports.Slider = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var children = _ref.children,
    styles = _ref.styles,
    qeId = _ref.qeId,
    childWidth = _ref.childWidth,
    childMarginRight = _ref.childMarginRight,
    NextIcon = _ref.NextIcon,
    PrevIcon = _ref.PrevIcon,
    WrapperComponent = _ref.WrapperComponent,
    ChildComponent = _ref.ChildComponent,
    hideFirstLastArrow = _ref.hideFirstLastArrow,
    disableSlider = _ref.disableSlider,
    infinite = _ref.infinite,
    onChildClick = _ref.onChildClick,
    afterPositionChange = _ref.afterPositionChange,
    setSliderPositionTo = _ref.setSliderPositionTo,
    isDynamicWidth = _ref.isDynamicWidth,
    ariaHideInactiveSlides = _ref.ariaHideInactiveSlides;
  var numSlides = _react["default"].Children.count(children);
  var sliderHookProps = (0, _useSliderHook.useSlider)({
    numSlides: numSlides,
    infinite: infinite,
    afterPositionChange: afterPositionChange
  });
  var SliderContolsProps = _objectSpread({
    numSlides: numSlides,
    PrevIcon: PrevIcon,
    NextIcon: NextIcon,
    styles: styles,
    hideFirstLastArrow: hideFirstLastArrow,
    afterPositionChange: afterPositionChange,
    hideAllArrows: disableSlider
  }, sliderHookProps);
  var sliderRef = (0, _react.useRef)();
  var _useState = (0, _react.useState)({
      width: childWidth,
      margin: childMarginRight
    }),
    _useState2 = _slicedToArray(_useState, 2),
    dynamicChildSize = _useState2[0],
    setDynamicChildSize = _useState2[1];
  var getInnerWidth = function getInnerWidth() {
    return (0, _utils.isBrowser)() && window.innerWidth;
  };
  var _useState3 = (0, _react.useState)(getInnerWidth()),
    _useState4 = _slicedToArray(_useState3, 2),
    windowWidth = _useState4[0],
    setWindowWidth = _useState4[1];
  var handleResize = function handleResize() {
    return setWindowWidth(getInnerWidth());
  };
  (0, _react.useEffect)(function () {
    if (isDynamicWidth) {
      window.addEventListener('resize', handleResize);
      return function () {
        window.removeEventListener('resize', handleResize);
      };
    }
    return undefined;
  }, [isDynamicWidth]); // eslint-disable-line react-hooks/exhaustive-deps

  var getWidthValue = function getWidthValue(nodeStyle) {
    return nodeStyle.getPropertyValue('flex-basis').includes('px') ? nodeStyle.getPropertyValue('flex-basis') : nodeStyle.getPropertyValue('width');
  };
  var calculateDynamicWidthAndMargin = (0, _react.useCallback)(function () {
    if (isDynamicWidth && windowWidth && sliderRef.current) {
      var nodeStyle = window.getComputedStyle(sliderRef.current);
      var width = getWidthValue(nodeStyle);
      var margin = nodeStyle.getPropertyValue('margin-right');
      if (width !== dynamicChildSize.width || margin !== dynamicChildSize.margin) {
        setDynamicChildSize({
          width: isNaN(parseInt(width, 10)) ? '0' : width,
          margin: isNaN(parseInt(margin, 10)) ? '0' : margin
        });
      }
    }
  }, [dynamicChildSize, isDynamicWidth, windowWidth, sliderRef, sliderRef.current]); // eslint-disable-line react-hooks/exhaustive-deps, max-len

  (0, _react.useEffect)(calculateDynamicWidthAndMargin, [isDynamicWidth, windowWidth, sliderRef, sliderRef.current]);
  (0, _react.useEffect)(function () {
    if (typeof setSliderPositionTo === 'number') {
      sliderHookProps.setPosition(setSliderPositionTo);
    }
  }, [setSliderPositionTo]); // eslint-disable-line react-hooks/exhaustive-deps

  var sliderMoveXAxis = sliderHookProps.position * (-parseInt(dynamicChildSize.width, 10) - parseInt(dynamicChildSize.margin, 10));
  sliderMoveXAxis = dynamicChildSize.width.includes('%') ? "".concat(sliderMoveXAxis, "%") : "".concat(sliderMoveXAxis, "px");
  var sliderChildStyles = isDynamicWidth ? {} : {
    marginRight: childMarginRight,
    flex: "0 0 ".concat(childWidth)
  };
  var setSliderRef = (0, _react.useCallback)(function (index) {
    return function (el) {
      if (index === 0 && !sliderRef.current) {
        sliderRef.current = el;
      }
    };
  }, []);
  var isChildFullWidth = (0, _react.useCallback)(function () {
    return childWidth === '100%';
  }, [childWidth]);
  return /*#__PURE__*/_react["default"].createElement(WrapperComponent, _extends({
    className: styles.wrapper,
    "data-qe-id": qeId
  }, sliderHookProps.swipeHandlers), /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.slidesContainer,
    style: {
      transform: "translateX(".concat(disableSlider ? 0 : sliderMoveXAxis, ")")
    }
  }, _react["default"].Children.map(children, function (child, index) {
    var ariaProp = ariaHideInactiveSlides || isChildFullWidth() ? {
      'aria-hidden': index !== sliderHookProps.position
    } : {};
    return /*#__PURE__*/_react["default"].createElement(ChildComponent, _extends({
      className: (0, _classnames["default"])(styles.slide, _defineProperty({}, styles.slideActive, styles.slideActive && index === sliderHookProps.position)),
      onClick: function onClick() {
        return onChildClick({
          index: index
        });
      },
      key: index
    }, ariaProp, {
      style: sliderChildStyles,
      "data-qe-id": "".concat(qeId, "-child"),
      ref: setSliderRef(index)
    }), child);
  })), /*#__PURE__*/_react["default"].createElement(_SliderControls.SliderControls, SliderContolsProps));
});
Slider.propTypes = {
  childWidth: _propTypes["default"].string,
  childMarginRight: _propTypes["default"].string,
  children: _propTypes["default"].node.isRequired,
  styles: _propTypes["default"].objectOf(_propTypes["default"].string),
  qeId: _propTypes["default"].string,
  NextIcon: _propTypes["default"].node,
  PrevIcon: _propTypes["default"].node,
  WrapperComponent: _propTypes["default"].node,
  ChildComponent: _propTypes["default"].node,
  hideFirstLastArrow: _propTypes["default"].bool,
  disableSlider: _propTypes["default"].bool,
  infinite: _propTypes["default"].bool,
  onChildClick: _propTypes["default"].func,
  afterPositionChange: _propTypes["default"].func,
  setSliderPositionTo: _propTypes["default"].number,
  isDynamicWidth: _propTypes["default"].bool,
  ariaHideInactiveSlides: _propTypes["default"].bool
};
Slider.defaultProps = {
  childWidth: '290px',
  childMarginRight: '20px',
  styles: {},
  qeId: 'acq-slider',
  NextIcon: SliderControlIcon,
  PrevIcon: SliderControlIcon,
  WrapperComponent: 'div',
  ChildComponent: 'div',
  hideFirstLastArrow: false,
  disableSlider: false,
  infinite: false,
  afterPositionChange: function afterPositionChange() {},
  onChildClick: function onChildClick() {},
  setSliderPositionTo: undefined,
  isDynamicWidth: false,
  ariaHideInactiveSlides: false
};